import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  part_number: Yup.string().required('Part Number é obrigatório'),
  sell_price: Yup.number().min(0, 'Valor não pode ser negativo').required('Valor é obrigatório'),
  cost_price: Yup.number()
    .min(0, 'Valor de custo não pode ser negativo')
    .required('Valor de custo é obrigatório'),
  process: Yup.array().min(1, 'Selecione pelo menos um processo'),
});
